import axios from 'axios'
import qs from 'qs'
import router from '@/router'
import store from '@/store'
import consts from '@/utils/consts.js';
import { getStore } from '@/utils/storage.js';

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 60000 // request timeout 60S
})

service.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
// service.defaults.headers.post['token'] = getStore(consts.KEY_USER_TOKEN);
// request interceptor
service.interceptors.request.use(
  config => {
	 // 解决post参数问题
    if (config.method === 'post') {
	     config.data = qs.stringify(config.data)
    }

    let token = getStore(consts.KEY_USER_TOKEN)
    let selectCountry = getStore(consts.KEY_SELECT_COUNTRY)
    let langCode = getStore(consts.EVENT_LANG_CHANGE)
    config.headers.token = (token && token.length > 0) ? token : ''
    config.headers.countryId = (selectCountry && selectCountry.length > 0) ? JSON.parse(selectCountry).id : ''
    config.headers.langCode = (langCode && langCode.length > 0) ? langCode : ''
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */
  response => {
    const res = response.data
     // session过期重新登录
    if (res.result == 0 && res.code == 1003015) {
      store.commit('DELETE_USERINFO')// 清除用户、登录状态数据
      router.push({
        path: '/login'
      })
      return
    } else if (res.result == 0 && res.code == 1003006) {
      // 接口异常
      let curRoutePath = store.state.curRoutePath
      if (curRoutePath.indexOf('/user/') > -1) {
        router.push({
          path: '/user/error'
        })
      }
    }
    return res
  },
  error => {
    if (error.response) {

    }
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js